"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const _ = require("lodash");
exports.TextareaComponent = (props) => {
    const { selectedItem, text, id, name, placeholder, maxLength, readOnly, labelName, setItem, disabled, required } = props;
    const handleChange = (e) => {
        let itemClone = _.cloneDeep(selectedItem);
        if (itemClone.hasOwnProperty("attributes"))
            itemClone.attributes[name] = e.target.value;
        else
            itemClone[name] = e.target.value;
        setItem(itemClone, true);
    };
    return (React.createElement("div", { className: "form-row" },
        React.createElement("div", { className: "col" },
            React.createElement("div", { className: "form-group" },
                React.createElement("label", null,
                    React.createElement("strong", null, labelName),
                    required ? required : React.createElement(React.Fragment, null)),
                React.createElement("textarea", { className: "form-control", id: id, name: name, placeholder: placeholder, value: text, onChange: handleChange, readOnly: readOnly, maxLength: maxLength, disabled: disabled })))));
};
//# sourceMappingURL=TextareaComponent.js.map